/*
 * @Author: 右侧内容重构
 * @Date:   2017-09-11 16:07:27
 * @Last Modified by:   Marte
 * @Last Modified time: 2017-12-04 19:09:07
 */

'use strict';
angular.module('myResourcesDetailModule', [])
    .directive('myResourcesDetail', ["$state", "$filter", "$location", "$timeout", '$stateParams', 'trsspliceString', 'resourceCenterService', 'modalDialog', 'trsHttpService', 'resCtrModalService', 'storageListenerService', function($state, $filter, $location, $timeout, $stateParams, trsspliceString, resourceCenterService, modalDialog, trsHttpService, resCtrModalService, storageListenerService) {
        // Runs during compile
        return {
            scope: {
                rebuildData: '='
            },
            restrict: 'AE',
            templateUrl: './networkResource/myResources/quickPreview/detail/detail_tpl.html',
            replace: true,
            link: function(scope, iElm, iAttrs, controller) {
                initStatus();
                initData();
                //infoget();
                /** [initData description] 初始化数据 */
                function initData() {
                    if (scope.rebuildData != "") {
                        requestData();
                    }
                }
                /** [initStatus description] 初始化状态 */
                function initStatus() {
                    scope.detailData = [];
                }
                /**
                 * [infoget description]获取取稿人
                 * @return {[type]} [description]
                 */
                /*function infoget() {
                    var params = {
                        methodname: 'queryFlagList',
                        serviceid: 'mlf_bigdataexchange',
                        guid: scope.rebuildData.guid
                    }
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        scope.infoneed = data.QU[0];
                    });
                };*/
                /**
                 * [getQuInfo description]获取取稿人信息（初始化，取稿之后调用）
                 * @return {[type]} [description]
                 */
                function getQuInfo() {
                    scope.detailData.quInfos = [];
                    var params = {
                        serviceid: "mlf_bigdataexchange",
                        methodname: "queryFlagList",
                        guid: scope.rebuildData.guid,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                        for (var j = 0; j < data.QU.length; j++) {
                            var fromtemp = data.QU[j];
                            var intotemp = {
                                COMPANY: fromtemp.COMPANY,
                                OPERUSER: fromtemp.OPERUSER //fromtemp.OPERUSER.split("-")[1]
                            };
                            scope.detailData.quInfos.push(intotemp);
                        }
                        scope.detailData.quInfos = $filter('unique')(scope.detailData.quInfos, 'OPERUSER');
                        scope.detailData.quInfoStr = "";
                        if (scope.detailData.quInfos.length > 1) {
                            for (var k = 0; k < scope.detailData.quInfos.length - 1; k++) {
                                scope.detailData.quInfoStr += scope.detailData.quInfos[k].OPERUSER + ";";
                            }
                            scope.detailData.quInfoStr += scope.detailData.quInfos[scope.detailData.quInfos.length - 1].OPERUSER;
                        } else if (scope.detailData.quInfos.length == 1) {
                            scope.detailData.quInfoStr = scope.detailData.quInfos[0].OPERUSER;
                        }
                    });

                }
                scope.$watch("rebuildData", function() {
                    if (scope.rebuildData != "") {
                        requestData();
                    }
                });
                /** [requestData description] 获取数据 */
                function requestData() {
                    var params = {
                        serviceid: "jtcpg",
                        modelid: "detailData",
                        guid: scope.rebuildData.guid,
                        typeid: "zyzx",
                        indexName: scope.rebuildData.indexName,
                    };
                    trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                        scope.detailData = data.content[0];
                        scope.detailData.keywordsArr = scope.detailData.ZB_KEYWORDS5 == "" ? [] : scope.detailData.ZB_KEYWORDS5.split(";");
                        getQuInfo();
                    });
                }
                /** [creationAxis description]加入个人素材 */
                scope.creationAxis = function() {
                    var params = {
                        typeid: 'zyzx',
                        PersonalMaterialId: 0,
                        serviceid: "mlf_bigdataexchange",
                        methodname: "batchPersonalMaterial",
                        guid: scope.rebuildData.guid,
                        channelName: "iwo",
                        indexName: scope.rebuildData.indexName
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        modalDialog.alertType("", "添加成功", "success", false, function() {

                        });
                    });
                };
                var nodeid = $stateParams.groupid;
                /**
                 * [plainView description] 普通视图
                 * @return {[type]} [description]
                 */


                /** [collect description] s收藏功能 */
                // 收藏
                scope.collect = function() {
                    var params = {
                        serviceid: "mlf_bigdataexchange",
                        methodname: "collect",
                        guid: scope.rebuildData.guid,
                        channelName: "iwo",
                        indexName: scope.rebuildData.indexName
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                        modalDialog.alertType("收藏成功!", "", "success", false, "");
                    });
                };
                /** [takeDraft description]取稿操作 */
                scope.takeDraft = function() {
                    var params = {
                        serviceid: "mlf_bigdataexchange",
                        methodname: "fetch",
                        guid: scope.rebuildData.guid,
                        channelName: 'iwo',
                        typeName: "73",
                        indexName: scope.rebuildData.indexName
                    };
                    var modalInstance = resCtrModalService.fullTakeDraft(params, false, [scope.rebuildData]);
                    modalInstance.result.then(function(data) {
                        takeDraftDownloadImgs(data).then(function() {
                            getQuInfo();
                            storageListenerService.addListenerToResource("takeDraft");
                        });
                    }, function() {});
                };
                /**
                 * [takeDraftDownloadImgs description]  图片正在下载中情况，跳转至下载弹窗
                 * @param  {[type]} data [description]
                 * @return {[type]}      [description]
                 */
                function takeDraftDownloadImgs(data) {
                    var deferred = $q.defer();
                    var needDownloadImg = false;
                    for (var i = 0; i < data.REPORTS.length; i++) {
                        if (data.REPORTS[i].PICERROR == 1) {
                            needDownloadImg = true;
                            break;
                        }
                    }
                    if (needDownloadImg) {
                        resCtrModalService.takeDraftDownloadImgs(data, function(res) {
                            deferred.resolve();
                        });
                    } else {
                        deferred.resolve();
                    }
                    return deferred.promise;
                }
                /**
                 * [plainView description] 返回 普通视图
                 * @return {[type]} [description]
                 */
                scope.plainView = function() {
                    $state.go("front.networksource.myresources.subscriptionfolderson", { groupid: $stateParams.groupid });
                };
            }
        };
    }]);
